// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2uNu2","sendOtp":"AuthorizeToLogin_sendOtp__Q91Nf"};